import { gspx } from '@rsos/capstone';

export const trackSessionStart = () => {
  gspx.trackCustomEvent('Auth Session', {
    name: 'Session Start',
    Category: 'Session tracking',
    'Launched date': new Date(),
  });
};

export const trackCSPlogin = () => {
  gspx.trackCustomEvent('Alert', {
    name: `CSP user login successfully`,
    Category: 'Alert',
    'Launched date': new Date(),
  });
};

export const trackCSPSSOLogin = () => {
  gspx.trackCustomEvent('Alert', {
    name: `SSO CSP user login successfully`,
    Category: 'Alert',
    'Launched date': new Date(),
  });
};

export const trackRequestResetPasswordSuccess = () => {
  gspx.trackCustomEvent('Auth', {
    Category: 'Auth',
    name: 'User reset password',
    'Launched date': new Date(),
  });
};

export const trackChangedPasswordSuccess = () => {
  gspx.trackCustomEvent('Auth', {
    Category: 'Auth',
    name: 'User changed password',
    'Launched date': new Date(),
  });
};

export const trackSSOUserError = () => {
  gspx.trackCustomEvent('Auth', {
    Category: 'Auth',
    name: 'SSO user error',
    'Launched date': new Date(),
  });
};
